export class UriBuilder {
  private uri = '';
  private getParameters: URLSearchParams = new URLSearchParams();

  /**
   * Create a new instance representing a relative URI initialized from a URI path.
   * @param fullPath
   */
  public fromPath(fullPath: string): UriBuilder {
    this.uri = fullPath;
    return this;
  }

  /**
   * Append path to the existing path.
   * @param pathElement
   */
  public path(pathElement: string | number): UriBuilder {
    this.uri = this.appendPath(this.uri, `${pathElement}`);
    return this;
  }

  /**
   * Add get parameters to the uri
   * @param params
   */
  public getParams(params: object): UriBuilder {
    Object.keys(params).forEach(k => this.getParameters.set(k, params[k]));
    return this;
  }

  public build(): string {
    if (this.uri.endsWith('/')) {
      this.uri = this.uri.replace(/.$/, '');
    }

    const query = this.getParameters.toString();
    if (query.length > 0) {
      this.uri += `?${query}`;
    }
    return this.uri;
  }

  /**
   * return <URL>/<PATH>
   */
  private appendPath(url: string, path: string): string {
    return [url, path].join('/');
  }
}
